let lastLocationRequest = {}
const REQUEST_CACHE_LIFE = 1000 * 60

function isGeolocationString (str)
{
    if (!str) return false
    
    const splitted = str.split(',')

    return splitted.length > 0 && splitted.every(part => !isNaN(part))
}

function stringToCoords (geoString)
{
    const geolocation = {}
    const splitted = geoString.split(',')
    
    geolocation.latitude = splitted[0]
    geolocation.longitude = splitted[1]
    
    if (splitted[2]) geolocation.accuracy = splitted[2]

    return geolocation
}

function coordsToString (coords)
{
    return `${coords.latitude},${coords.longitude},${coords.accuracy}`
}

function generateGoogleMapLinkFromCoords (geolocation)
{
    if (typeof geolocation == 'string')
    {
        geolocation = stringToCoords(geolocation)
    }

    const link = `https://www.google.com/maps/search/?api=1&query=${geolocation.latitude},${geolocation.longitude}`
    console.log(`Generating google map link from coords ${JSON.stringify(geolocation)} -> ${link}`)

    return link
}

function generateGoogleMapLinkFromAddress (address)
{
    const link = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    console.log(`Generating google map link from address ${address} -> ${link}`)

    return link
}

function requestHightAccuracyGeolocationAsync ()
{
    return new Promise((resolve, reject) =>
    {
        if (cordova.platformId != 'android' && cordova.platformId != 'ios') return resolve()

        cordova.plugins.locationAccuracy.request(async success =>
        {
            // first location request is sometimes a lot less accurate than the following, thus preparing..
            await getCurrentPositionAsync()
            resolve(success)

        }, reject, cordova.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY)
    })
}

function getCurrentPositionAsync ({ enableHighAccuracy = true, timeout = 5000 } = {})
{
    const requestId = Math.random().toString().substr(-4)
    console.log(`Requesting geolocation with parameters (${requestId})`, { enableHighAccuracy, timeout })

    return new Promise((resolve, reject) =>
    {
        navigator.geolocation.getCurrentPosition(success =>
        {
            console.log(`Geolocation request success (${requestId})`, success)
            resolve(success)

            lastLocationRequest = success
        },
        error =>
        {
            console.error(`Geolocation request failed (${requestId})`, error)
            
            const lastRequestAge = Date.now() - lastLocationRequest.timestamp
            if (lastRequestAge < REQUEST_CACHE_LIFE)
            {
                console.log('Using last request', lastLocationRequest, `which is aged of ${lastRequestAge}ms to serve request ${requestId}`)
                resolve(lastLocationRequest)
            }
            else reject(error)

        }, { enableHighAccuracy, timeout })
    })
}

export default { isGeolocationString, stringToCoords, coordsToString, generateGoogleMapLinkFromCoords, generateGoogleMapLinkFromAddress,
    requestHightAccuracyGeolocationAsync, getCurrentPositionAsync }


// WEBPACK FOOTER //
// ./src/utils/geolocationUtils.js